import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {VoipPeersComponent} from './voip-peers.component';
import { VoipPeersDialogComponent } from './voip-peers-dialog/voip-peers-dialog.component';
import {PipsModule} from '../../pipes/pips.module';
import {FlexModule} from '@angular/flex-layout';
import {DialogModule} from '../../components/dialog/dialog.module';
import {FormsModule} from '@angular/forms';
import {ColumnsFilterModule} from '../../components/columns-filter/columns-filter.module';
import {LayoutModule} from '../../components/layout/layout.module';
import {SearchModule} from '../../components/search/search.module';
import { VoipPeersSearchComponent } from './voip-peers-search/voip-peers-search.component';
import {MaterialModule} from '../../material.module';
import {ActionBarModule} from '../../components/action-bar/action-bar.module';
import {ArmTableModule} from '../../components/arm-table/arm-table.module';
import {InfraModule} from 'ac-infra';
@NgModule({
  declarations: [
    VoipPeersComponent,
    VoipPeersDialogComponent,
    VoipPeersSearchComponent
  ],
    imports: [
        CommonModule,
        PipsModule,
        FlexModule,
        DialogModule,
        FormsModule,
        ColumnsFilterModule,
        LayoutModule,
        SearchModule,
        MaterialModule,
        ActionBarModule,
        ArmTableModule,
        InfraModule
    ]
})
export class VoipPeersModule { }
